import type { QueryValidationResult } from 'api/data/client-dataapi';
import { useApi } from 'api/useApi';
import { ENV_VARS } from 'app/config/environment-vars';

const QUERY_VALIDATION_ERROR_KEY = 'MetaApiClient';

export const useQueryValidationApi = () => {
  const baseURL = `${ENV_VARS.DATA_URL}/api`;
  const fetchFunction = useApi(baseURL, QUERY_VALIDATION_ERROR_KEY);

  const get = (templateId: string, queryId: string) =>
    fetchFunction<QueryValidationResult>(`validations/${templateId}/queries/${queryId}`);

  const getAll = (templateId: string) => fetchFunction<QueryValidationResult[]>(`validations/${templateId}`);

  return {
    get,
    getAll
  };
};
